<!-- Hero-->
<section class="container-fluid py-5 mt-4 px-sm-4 px-md-5">
  <div class="rounded-5 bg-dark overflow-hidden mt-2 mx-md-n3 mx-lg-auto" style="max-width: 1660px;">
    <swiper-container #heroCarousel init="false">
      <swiper-slide>
        <div class="card border-0 position-relative h-160">
          <div class="position-absolute top-0 start-0 w-100 h-100 rounded-5 overflow-hidden bg-black bg-opacity-50">
            <div class="position-relative p-5 mt-10 mt-sm-0 zindex-2 text-center text-md-start">
              <h1 class="display-1 text-primary fw-bolder mb-0">
                Beneficiul perfect
              </h1>
              <h2 class="display-3 fw-bold text-light">pentru angajatii tai!</h2>
              <a [routerLink]="['/card-cadou-corporate']" class="btn btn-outline-light btn-lg mt-sm-4">Cum
                functioneaza</a>
            </div>
          </div>
          <img src="/assets/images/main-slider/7.jpg" class="card-img h-100 d-none d-sm-block"
            style="object-fit: cover; object-position: center center;" alt="Corporate">
          <img src="/assets/images/main-slider/7-mobile.jpg" class="card-img h-100 d-sm-none"
            style="object-fit: cover; object-position: center center;" alt="Corporate">
        </div>
      </swiper-slide>
      <ng-container *ngIf="isPlatformBrowser">
        <swiper-slide>
          <div class="card border-0 position-relative h-160">
            <div class="position-absolute top-0 start-0 w-100 h-100 rounded-5 overflow-hidden bg-black bg-opacity-50">
              <div class="position-relative p-5 mt-10 mt-sm-0 zindex-2 text-center text-md-start">
                <h1 class="display-1 text-primary fw-bolder mb-0">
                  Cadoul perfect exista!
                </h1>
                <h2 class="display-3 fw-bold text-light">Cardul Cadou GiftShare
                  <br>Peste {{(systemStatistics$ | async)?.voucherNonCharityCount}} de magazine partenere
                </h2>
                <a [routerLink]="['/cum-functioneaza']" class="btn btn-outline-light btn-lg mt-sm-4">Cum
                  functioneaza</a>
              </div>
            </div>
            <img src="/assets/images/main-slider/0.jpg" class="card-img h-100 d-none d-sm-block"
              style="object-fit: cover; object-position: center right;" alt="Corporate">
            <img src="/assets/images/main-slider/0-mobile.jpg" class="card-img h-100 d-sm-none"
              style="object-fit: cover; object-position: center center;" alt="Corporate">
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="card border-0 position-relative h-160">
            <div class="position-absolute top-0 start-0 w-100 h-100 rounded-5 overflow-hidden bg-black bg-opacity-50">
              <div class="position-relative p-5 mt-10 mt-sm-0 zindex-2 text-center text-md-start">
                <h1 class="display-1 text-primary fw-bolder mb-0">
                  Cadoul perfect
                </h1>
                <h2 class="display-3 fw-bold text-light"> pentru aniversare sau onomastica!</h2>
                <a [routerLink]="['/cum-functioneaza']" class="btn btn-outline-light btn-lg mt-sm-4">Cum
                  functioneaza</a>
              </div>
            </div>
            <img src="/assets/images/main-slider/1.jpg" class="card-img h-100 d-none d-sm-block"
              style="object-fit: cover; object-position: center right;" alt="Aniversare">
            <img src="/assets/images/main-slider/1-mobile.jpg" class="card-img h-100 d-sm-none"
              style="object-fit: cover; object-position: center center;" alt="Aniversare">
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="card border-0 position-relative h-160">
            <div class="position-absolute top-0 start-0 w-100 h-100 rounded-5 overflow-hidden bg-black bg-opacity-50">
              <div class="position-relative p-5 mt-10 mt-sm-0 zindex-2 text-center text-md-start">
                <h1 class="display-1 text-primary fw-bolder mb-0">
                  Cadoul perfect
                </h1>
                <h2 class="display-3 fw-bold text-light">pentru o petrecere de casa noua!</h2>
                <a [routerLink]="['/cum-functioneaza']" class="btn btn-outline-light btn-lg mt-sm-4">Cum
                  functioneaza</a>
              </div>
            </div>
            <img src="/assets/images/main-slider/5.jpg" class="card-img h-100 d-none d-sm-block"
              style="object-fit: cover; object-position: center center;" alt="Casa noua">
            <img src="/assets/images/main-slider/5-mobile.jpg" class="card-img h-100 d-sm-none"
              style="object-fit: cover; object-position: center center;" alt="Casa noua">
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="card border-0 position-relative h-160">
            <div class="position-absolute top-0 start-0 w-100 h-100 rounded-5 overflow-hidden bg-black bg-opacity-50">
              <div class="position-relative p-5 mt-10 mt-sm-0 zindex-2 text-center text-md-start">
                <h1 class="display-1 text-primary fw-bolder mb-0">
                  Cadoul perfect
                </h1>
                <h2 class="display-3 fw-bold text-light">pentru cununie sau casatorie!</h2>
                <a [routerLink]="['/cum-functioneaza']" class="btn btn-outline-light btn-lg mt-sm-4">Cum
                  functioneaza</a>
              </div>
            </div>
            <img src="/assets/images/main-slider/2.jpg" class="card-img h-100 d-none d-sm-block"
              style="object-fit: cover; object-position: center left;" alt="Casatorie">
            <img src="/assets/images/main-slider/2-mobile.jpg" class="card-img h-100 d-sm-none"
              style="object-fit: cover; object-position: center center;" alt="Casatorie">
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="card border-0 position-relative h-160">
            <div class="position-absolute top-0 start-0 w-100 h-100 rounded-5 overflow-hidden bg-black bg-opacity-50">
              <div class="position-relative p-5 mt-10 mt-sm-0 zindex-2 text-center text-md-start">
                <h1 class="display-1 text-primary fw-bolder mb-0">
                  Cadoul perfect
                </h1>
                <h2 class="display-3 fw-bold text-light">pentru baby shower sau botez!</h2>
                <a [routerLink]="['/cum-functioneaza']" class="btn btn-outline-light btn-lg mt-sm-4">Cum
                  functioneaza</a>
              </div>
            </div>
            <img src="/assets/images/main-slider/3.jpg" class="card-img h-100 d-none d-sm-block"
              style="object-fit: cover; object-position: center right;" alt="Nou nascut">
            <img src="/assets/images/main-slider/3-mobile.jpg" class="card-img h-100 d-sm-none"
              style="object-fit: cover; object-position: center center;" alt="Nou nascut">
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="card border-0 position-relative h-160">
            <div class="position-absolute top-0 start-0 w-100 h-100 rounded-5 overflow-hidden bg-black bg-opacity-50">
              <div class="position-relative p-5 mt-10 mt-sm-0 zindex-2 text-center text-md-start">
                <h1 class="display-1 text-primary fw-bolder mb-0">
                  Daruieste
                </h1>
                <h2 class="display-3 fw-bold text-light">o fapta buna!</h2>
                <a [routerLink]="['/cum-functioneaza']" class="btn btn-outline-light btn-lg mt-sm-4">Cum
                  functioneaza</a>
              </div>
            </div>
            <img src="/assets/images/main-slider/4.jpg" class="card-img h-100 d-none d-sm-block"
              style="object-fit: cover; object-position: center center;" alt="Caritate">
            <img src="/assets/images/main-slider/4-mobile.jpg" class="card-img h-100 d-sm-none"
              style="object-fit: cover; object-position: center center;" alt="Caritate">
          </div>
        </swiper-slide>
      </ng-container>
    </swiper-container>


  </div>
</section>

<!-- Partners-->
<section class="pb-5 pt-2 pt-sm-3 pt-md-4 pt-lg-5 my-xl-3 my-xxl-5">
  <div class="container pb-4 mb-2 mb-lg-3">
    <h2 class="h1 text-center">O parte dintre partenerii GiftShare</h2>
  </div>

  <ng-template #imageLoadingTemplate>
    <div class="position-relative placeholder-glow" aria-hidden="true">
      <div class="placeholder ratio ratio-4x3"></div>
      <i class="ai-image position-absolute top-50 start-50 translate-middle fs-1 opacity-50"></i>
    </div>
  </ng-template>

  <swiper-container #partnerCarousel init="false">
    <swiper-slide *ngFor="let x of partnerSlides">
      <div class="py-1">
        <a *ngIf="x.image; else imageLoadingTemplate" [routerLink]="['/carduri-cadou', x.slug]">
          <img class="mx-auto rounded-3" [src]="x.image" width="196" [alt]="x.name">
        </a>
      </div>
    </swiper-slide>

  </swiper-container>
</section>

<section class="bg-dark dark-mode border-top border-bottom border-light py-2 py-sm-3 py-md-4 py-lg-5">
  <div class="container py-5 my-lg-3 my-xl-4 my-xxl-5">
    <h2 class="h1 pb-3 pb-md-4 mb-0 mb-sm-2 mb-lg-3 text-center">GiftShare, solutia perfecta pentru orice ocazie</h2>
    <div class="row align-items-center pt-sm-2 pt-md-0 pt-xl-1 pt-xxl-3">
      <div class="col-md-6 col-xl-5 offset-xl-1 order-md-2 pb-4 pb-md-0 mb-2 mb-md-0 position-relative">
        <div class="d-block position-relative">
          <div class="rounded-5 position-absolute top-0 start-0 w-100 h-100"></div>
          <img class="d-block position-relative zindex-2" src="assets/images/resource/corporate-card.png" alt="Image">
        </div>
      </div>
      <div class="col-md-6 order-md-1">
        <!-- Nav tabs-->
        <ul ngbNav #nav="ngbNav" class="nav-tabs flex-column flex-sm-row text-nowrap pb-3 mb-3 mb-xl-4">
          <li [ngbNavItem]="1">
            <a ngbNavLink>Pentru angajati</a>
            <ng-template ngbNavContent>
              <h3 class="mb-lg-4">De ce sa oferi Cardul Cadou GiftShare?</h3>
              <p class="mb-lg-4">Ofera Cardul Cadou GiftShare angajatilor iar acestia isi vor putea alege <span
                  class="text-primary">#BeneficiulPerfect</span> de la cele peste {{(systemStatistics$ |
                async)?.voucherNonCharityCount}} magazine partenere GiftShare.</p>
              <ul class="list-unstyled pb-3 mb-3 mb-lg-4">
                <li class="d-flex pt-1 mt-2"><i class="ai-check-alt text-warning fs-4 mt-n1 me-2"></i>Flexibilitate in
                  utilizare</li>
                <li class="d-flex pt-1 mt-2"><i class="ai-check-alt text-warning fs-4 mt-n1 me-2"></i>Personalizare cu
                  text si logo</li>
                <li class="d-flex pt-1 mt-2"><i class="ai-check-alt text-warning fs-4 mt-n1 me-2"></i>2 ani valabilitate
                </li>
                <li class="d-flex pt-1 mt-2"><i class="ai-check-alt text-warning fs-4 mt-n1 me-2"></i>Reminder de
                  folosire la 30 zile, 90 zile si cu 30 zile inainte de expirare (23 luni)</li>
                <li class="d-flex pt-1 mt-2"><i class="ai-check-alt text-warning fs-4 mt-n1 me-2"></i>Trimitere
                  programata</li>
                <li class="d-flex pt-1 mt-2"><i class="ai-check-alt text-warning fs-4 mt-n1 me-2"></i>Rapoarte de
                  utilizare</li>
                <li class="d-flex pt-1 mt-2"><i class="ai-check-alt text-warning fs-4 mt-n1 me-2"></i>Transmitere 100%
                  digitala (protejam planeta! 🍃)</li>
                <li class="d-flex pt-1 mt-2"><i class="ai-check-alt text-warning fs-4 mt-n1 me-2"></i>Posibilitatea de a
                  dona (total sau partial) catre un ONG</li>
              </ul>
              <a [routerLink]="['/card-cadou-corporate']" class="btn btn-lg btn-link px-0 mt-n2 mt-lg-0">Afla mai
                multe<i class="ai-arrow-right ms-2"></i></a>
            </ng-template>
          </li>
          <li [ngbNavItem]="2">
            <a ngbNavLink>Pentru prieteni</a>
            <ng-template ngbNavContent>
              <h3 class="mb-lg-4">De ce sa oferi prietenilor Cardul Cadou GiftShare?</h3>
              <p class="mb-lg-4">Indiferent de evenimentul sarbatorit, acum este foarte simplu sa oferi <span
                  class="text-primary">#CadoulPerfect</span>! Daruind Cardul Cadou GiftShare oferi posibilitatea
                sarbatoritului sa isi aleaga exact ce isi doreste de la cele peste {{(systemStatistics$ |
                async)?.voucherNonCharityCount}} magazine partenere GiftShare.</p>
              <ul class="list-unstyled pb-3 mb-3 mb-lg-4">
                <li class="d-flex pt-1 mt-2"><i class="ai-check-alt text-warning fs-4 mt-n1 me-2"></i>Flexibilitate in
                  utilizare - peste {{(systemStatistics$ | async)?.voucherNonCharityCount}} magazine partenere din
                  categorii diverse</li>
                <li class="d-flex pt-1 mt-2"><i class="ai-check-alt text-warning fs-4 mt-n1 me-2"></i>Personalizare cu
                  text si poza</li>
                <li class="d-flex pt-1 mt-2"><i class="ai-check-alt text-warning fs-4 mt-n1 me-2"></i>2 ani valabilitate
                </li>
                <li class="d-flex pt-1 mt-2"><i class="ai-check-alt text-warning fs-4 mt-n1 me-2"></i>Reminder de
                  folosire la 30 zile, 90 zile si cu 30 zile inainte de expirare (23 luni)</li>
                <li class="d-flex pt-1 mt-2"><i class="ai-check-alt text-warning fs-4 mt-n1 me-2"></i>Trimitere
                  programata</li>
                <li class="d-flex pt-1 mt-2"><i class="ai-check-alt text-warning fs-4 mt-n1 me-2"></i>Transmitere 100%
                  digitala (protejam planeta! 🍃)</li>
                <li class="d-flex pt-1 mt-2"><i class="ai-check-alt text-warning fs-4 mt-n1 me-2"></i>Posibilitatea de a
                  dona (total sau partial) catre un ONG</li>
              </ul>
              <a [routerLink]="['/card-cadou-giftshare']" class="btn btn-lg btn-link px-0 mt-n2 mt-lg-0">Afla mai
                multe<i class="ai-arrow-right ms-2"></i></a>
            </ng-template>
          </li>
          <li [ngbNavItem]="3">
            <a ngbNavLink>Pentru concursuri</a>
            <ng-template ngbNavContent>
              <h3 class="mb-lg-4">De ce sa oferi Cardul Cadou GiftShare?</h3>
              <p class="mb-lg-4">Acum este foarte usor sa oferi <span class="text-primary">#PremiulPerfect</span> la
                concursuri! Ofera Cardul Cadou GiftShare iar castigatorii isi vor putea alege <span
                  class="text-primary">#PremiulPerfect</span> de la cele peste {{(systemStatistics$ |
                async)?.voucherNonCharityCount}} magazine partenere GiftShare.</p>
              <ul class="list-unstyled pb-3 mb-3 mb-lg-4">
                <li class="d-flex pt-1 mt-2"><i class="ai-check-alt text-warning fs-4 mt-n1 me-2"></i>Flexibilitate in
                  utilizare</li>
                <li class="d-flex pt-1 mt-2"><i class="ai-check-alt text-warning fs-4 mt-n1 me-2"></i>Personalizare cu
                  text si logo</li>
                <li class="d-flex pt-1 mt-2"><i class="ai-check-alt text-warning fs-4 mt-n1 me-2"></i>2 ani valabilitate
                </li>
                <li class="d-flex pt-1 mt-2"><i class="ai-check-alt text-warning fs-4 mt-n1 me-2"></i>Reminder de
                  folosire la 30 zile, 90 zile si cu 30 zile inainte de expirare (23 luni)</li>
                <li class="d-flex pt-1 mt-2"><i class="ai-check-alt text-warning fs-4 mt-n1 me-2"></i>Trimitere
                  programata</li>
                <li class="d-flex pt-1 mt-2"><i class="ai-check-alt text-warning fs-4 mt-n1 me-2"></i>Rapoarte de
                  utilizare</li>
                <li class="d-flex pt-1 mt-2"><i class="ai-check-alt text-warning fs-4 mt-n1 me-2"></i>Transmitere 100%
                  digitala (protejam planeta! 🍃)</li>
                <li class="d-flex pt-1 mt-2"><i class="ai-check-alt text-warning fs-4 mt-n1 me-2"></i>Posibilitatea de a
                  dona (total sau partial) catre un ONG</li>
              </ul>
              <a [routerLink]="['/card-cadou-concursuri']" class="btn btn-lg btn-link px-0 mt-n2 mt-lg-0">Afla mai
                multe<i class="ai-arrow-right ms-2"></i></a>
            </ng-template>
          </li>
        </ul>

        <!-- Tab content-->
        <div [ngbNavOutlet]="nav" class="tab-content pt-lg-2 pt-xl-3"></div>
      </div>
    </div>
  </div>
</section>


<!-- Featured media -->
<section class="pb-5 pt-5 my-xl-3 my-xxl-5">
  <div class="container pb-4 mb-2 mb-lg-3">
    <h2 class="h1 text-center">Aparitii media</h2>
  </div>

  <swiper-container #featuredMediaCarousel init="false">
    <swiper-slide *ngFor="let x of featuredMediaSlides">
      <div class="rounded-4">
        <a [href]="x.url" target="_blank">
          <img class="grayscale mx-auto rounded-3" [src]="x.image" width="196" [alt]="x.name">
        </a>
      </div>
    </swiper-slide>
  </swiper-container>

</section>

<!-- Popular articles -->
<section class="bg-faded-primary py-1">
  <div class="container pt-5 pb-3 mt-2 mt-sm-4 mb-2 mb-md-3 mb-lg-4 mb-xxl-5">
    <!-- <h2 class="h1 pt-2 pt-sm-3 pb-3 mb-3 mb-lg-4 text-center">Postari Blog Recente</h2> -->
    <div class="container pb-4 mb-2 mb-lg-3">
      <h2 class="h1 text-center">Postari Blog Recente</h2>
    </div>

    <swiper-container space-between="24" pagination="true" pagination-clickable="true"
      pagination-el=".swiper-pagination" [breakpoints]="{
          '0': {
            slidesPerView: 1
          },
          '576': {
            slidesPerView: 2
          },
          '992': {
            slidesPerView: 3
          }
        }">

      <ng-container *ngIf="!blogPosts">
        <swiper-slide *ngFor="let x of [].constructor(3)">
          <article class="swiper-slide h-auto">
            <div class="card border-0 h-100" aria-hidden="true">
              <div class="position-relative placeholder-glow">
                <div class="card-img-top placeholder ratio ratio-16x9"></div>
                <i class="ai-image position-absolute top-50 start-50 translate-middle fs-1 opacity-50"></i>
              </div>
              <div class="card-body">
                <h5 class="card-title placeholder-glow">
                  <span class="placeholder col-6"></span>
                </h5>
                <p class="card-text placeholder-glow">
                  <span class="placeholder placeholder-sm col-7 me-2"></span>
                  <span class="placeholder placeholder-sm col-4"></span>
                  <span class="placeholder placeholder-sm col-4 me-2"></span>
                  <span class="placeholder placeholder-sm col-6"></span>
                  <span class="placeholder placeholder-sm col-8"></span>
                </p>
              </div>
            </div>
          </article>
        </swiper-slide>
      </ng-container>

      <ng-container *ngIf="blogPosts">
        <swiper-slide *ngFor="let x of blogPosts | slice:0:3">
          <article class="swiper-slide h-auto">
            <div class="card border-0 h-100">
              <a [href]="x.link">
                <img [src]="x._embedded['wp:featuredmedia'][0].media_details.sizes['post-thumbnail'].source_url"
                  class="card-img-top" [alt]="x.title.rendered">
              </a>
              <div class="card-body pb-4">
                <div class="d-flex align-items-center mb-4 mt-n1"><span class="fs-sm text-muted">{{ x.date_gmt |
                    dfnsFormatDistanceToNowStrictPure:{addSuffix: true} }}</span>
                  <ng-container *ngIf="x._embedded['wp:term'][0]?.length > 0">
                    <span class="fs-xs opacity-20 mx-3">|</span>
                    <a *ngFor="let category of x._embedded['wp:term'][0]" [href]="category.link">
                      <span class="badge bg-faded-info text-info fs-sm border me-1 mb-1">{{category.name}}</span>
                    </a>
                  </ng-container>
                </div>
                <h3 class="h4 card-title text-truncate"><a [href]="x.link">{{x.title.rendered}}</a></h3>
                <p *ngIf="x.excerpt?.rendered" [innerHTML]="getBlogSummary(x.excerpt.rendered)" class="card-text">
                </p>
              </div>
              <div class="card-footer pt-3">
                <h6>Postat de <a [href]="x._embedded.author[0].link">{{x._embedded.author[0].name}}</a></h6>
                <div class="text-decoration-none">
                  <ng-container *ngIf="x._embedded['wp:term'][1]?.length > 0">
                    <a *ngFor="let tag of x._embedded['wp:term'][1] | slice:0:2" [href]="tag['link']">
                      <span class="badge text-nav fs-xs border me-1 mb-1">{{tag['name']}}</span>
                    </a>
                  </ng-container>
                </div>
              </div>
            </div>
          </article>
        </swiper-slide>
      </ng-container>

    </swiper-container>
    <!-- Pagination (bullets)-->
    <div class="swiper-pagination position-relative bottom-0 mt-2 pt-4 d-lg-none"></div>
    <!-- All articles button-->
    <div class="container text-center pt-4 pb-1 pb-sm-3 pb-md-4 py-lg-5 mb-xl-1 mb-xxl-4 mt-2 mt-lg-0"><a
        [href]="blogUrl" class="btn btn-outline-primary">Toate postarile</a></div>

  </div>
</section>
